import React, { useState } from 'react';
import './About.css';

function About() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      question: "how long does shipping take?",
      answer: "typically 3-5 business days within the continental US. international shipping may take 7-14 business days."
    },
    {
      question: "what types of light bulbs can I use?",
      answer: "our lamp shades are compatible with standard LED and incandescent bulbs up to 60W. we recommend LED bulbs for optimal energy efficiency."
    },
    {
      question: "can I modify my design after ordering?",
      answer: "yes, you can modify your design up until we begin the printing process. contact our support team for assistance."
    },
    {
      question: "what is your return policy?",
      answer: "we offer a 30-day satisfaction guarantee. if you're not completely satisfied with your lamp shade, we'll work with you to make it right."
    },
    {
      question: "how do I clean my lamp shade?",
      answer: "use a soft, dry cloth to gently dust your lamp shade. for deeper cleaning, a slightly damp cloth can be used, but avoid harsh chemicals."
    },
    {
      question: "do you offer custom sizes?",
      answer: "yes, we can accommodate custom sizes. please contact our support team with your specific requirements."
    }
  ];

  return (
    <div className="about">
      <h1 className="centered-heading">HOW IT WORKS</h1>
      <section className="about-section full-width">
        <div className="section-content">
          <div className="steps-list">
            <div className="step">
              <span className="step-number">1</span>
              <div className="step-content">
                <h2>DESIGN</h2>
                <p>choose from our curated preset designs and modify them to your liking, or start from scratch to create your own unique lamp shade using our intuitive online tool</p>
              </div>
            </div>
            <div className="step">
              <span className="step-number">2</span>
              <div className="step-content">
                <h2>SUBMIT</h2>
                <p>create unique patterns, shapes, and textures for your perfect lighting solution. save your lamp design to complete later, load a previous design file, or export your STL design file to submit</p>
              </div>
            </div>
            <div className="step">
              <span className="step-number">3</span>
              <div className="step-content">
                <h2>PRINT</h2>
                <p>submit your design file when you're happy with the result. we will then review, prepare, and 3D print your lamp design</p>
              </div>
            </div>
            <div className="step">
              <span className="step-number">4</span>
              <div className="step-content">
                <h2>SEND</h2>
                <p>once the printing and assemblage processes are complete, we will ship your design directly to you</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section reverse">
        <div className="section-content">
          <h2>FABRICATION PROCESS</h2>
          <p>
            after receiving your design, we use state-of-the-art 3d printing technology to bring your lamp shade to life. our advanced printers create each piece with precision and care, ensuring that every detail of your design is perfectly captured. the printing process typically takes 24-48 hours, after which we carefully package your creation for shipping.
          </p>
        </div>
        <div className="section-image"></div>
      </section>

      <section className="about-section">
        <div className="section-content">
          <h2>MATERIALS</h2>
          <p>
            we use high-quality, eco-friendly materials for all our lamp shades. our primary material is a premium bioplastic that offers both durability and sustainability. each lamp shade is finished with a protective coating that enhances its appearance while ensuring long-lasting performance. the material is also heat-resistant and safe for use with standard light bulbs.
          </p>
        </div>
        <div className="section-image"></div>
      </section>

      <section className="about-section">
        <div className="section-content">
          <h2>OUR VALUES</h2>
          <div className="values-grid">
            <div className="value-item">
              <h3>INNOVATION</h3>
              <p>pushing the boundaries of what's possible in lighting design</p>
            </div>
            <div className="value-item">
              <h3>QUALITY</h3>
              <p>uncompromising standards in every lamp we create</p>
            </div>
            <div className="value-item">
              <h3>SUSTAINABILITY</h3>
              <p>eco-friendly materials and responsible manufacturing</p>
            </div>
            <div className="value-item">
              <h3>ACCESSIBILITY</h3>
              <p>making custom lighting available to everyone</p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section">
        <div className="section-content">
          <h2>FAQ'S</h2>
          <div className="faq-grid">
            {faqs.map((faq, index) => (
              <div key={index} className="faq-item">
                <button 
                  className={`faq-question ${openFaq === index ? 'active' : ''}`}
                  onClick={() => toggleFaq(index)}
                >
                  <h3>{faq.question}</h3>
                  <span className="faq-icon">{openFaq === index ? '−' : '+'}</span>
                </button>
                <div className={`faq-answer ${openFaq === index ? 'open' : ''}`}>
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About; 